import React, { useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { FulfillmentContent } from './FulfillmentDashboardPage';
import SOGroupedFulfillmentView from './fulfillment/SOGroupedFulfillmentView';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';

/**
 * Purchase Fulfillment (New) — toggle between By SO (default) and By Item (legacy).
 */
export default function PurchaseFulfillmentNewPage() {
  const [view, setView] = useState('by-so');
  return (
    <DashboardLayout>
      <Tabs value={view} onValueChange={setView} className="space-y-3">
        <TabsList>
          <TabsTrigger value="by-so" data-testid="tab-view-by-so">By Sales Order</TabsTrigger>
          <TabsTrigger value="by-item" data-testid="tab-view-by-item">By Item (legacy)</TabsTrigger>
        </TabsList>
        <TabsContent value="by-so" className="m-0">
          <SOGroupedFulfillmentView mode="purchase" />
        </TabsContent>
        <TabsContent value="by-item" className="m-0">
          <FulfillmentContent mode="mp" />
        </TabsContent>
      </Tabs>
    </DashboardLayout>
  );
}
